export default "__VITE_ASSET__Bh5eKEDC__"